import { StackActions, useNavigation } from "@react-navigation/native";
import { Block } from "app/shared/components/blocks/block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ConfirmOTP from "app/shared/components/otp/otp";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import { ServiceCode } from "app/shared/services/api-path";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { fetchCardAuthorizationRequest, setCardStore } from "../../reducer/actions";
import { getCardStoreSelector } from "../../reducer/selectors";

const CardAuth = () => {
  const { dispatch, goBack } = useNavigation();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();

  const cardStore = useSelector(getCardStoreSelector);

  const resetData = () => {
    dispatchStore(
      setCardStore({
        ...cardStore,
        statusCardAuth: "init",
        statusCardConfirm: "init",
        resCardConfirm: undefined,
        resCardAuth: undefined,
        errorOTP: false,
      }),
    );
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        resetData();
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("CARD_DICH_VU_THE"),
      onPressSubtitle: () => {
        onCancel();
      },
    },
    {
      name: t("STEP_XAC_THUC"),
      onPressSubtitle: () => {},
    },
  ];

  const onSubmit = ({ otpCode = "" }) => {
    dispatchStore(fetchCardAuthorizationRequest(cardStore.resCardConfirm, otpCode, true));
  };

  const onCancel = () => {
    resetData();
    goBack();
  };

  React.useEffect(() => {
    if (cardStore.statusCardAuth === "ok") {
      goBack();
    }
  }, [cardStore.statusCardAuth, goBack]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("STEP_XAC_THUC")} subtitles={subtitlesArrays} />
        <ConfirmOTP
          goBack={onCancel}
          onSubmit={onSubmit}
          isReset={cardStore.statusCardAuth === "ok"}
          serviceCode={ServiceCode.CARD}
          errorEndOTP={cardStore.errorOTP}
          verification={cardStore.resCardConfirm}
        />
      </ScrollView>
    </Block>
  );
};

export default CardAuth;
